import { useLayoutEffect, useState, type RefObject } from 'react';
import { claimReturnTransitionNames, isReturnTransitionTarget } from '@/utils/viewTransition';

/**
 * Reverse (profile -> origin) shared-element morph for a card that has a photo
 * and a title element. Returns true when this card is the pending morph target;
 * the card should then skip its entrance animation (`initial={false}`) so the
 * "new" snapshot sees it at final size and opacity. Read once at first render.
 * The names are claimed in a layout effect, before the snapshot is captured.
 * See `src/utils/viewTransition.ts`.
 */
export function useRestaurantReturnTarget(
  restaurantId: number,
  photoRef: RefObject<HTMLElement | null>,
  titleRef: RefObject<HTMLElement | null>,
): boolean {
  const [isReturnTarget] = useState(() => isReturnTransitionTarget(restaurantId));
  useLayoutEffect(() => {
    claimReturnTransitionNames(restaurantId, photoRef, titleRef);
  }, [restaurantId, photoRef, titleRef]);
  return isReturnTarget;
}
